import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { DialogTitle, IconButton, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/CloseSharp';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

const useTitleStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

const useStyles = makeStyles(theme => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
}));

export const ChangeResourceDialogTitle = ({ dialogTitleId, onClose }) => {
  const titleClasses = useTitleStyles();
  const classes = useStyles();

  const { isSubmitting } = useFormikContext();
  const { formatMessage } = useIntl();

  return (
    <DialogTitle classes={titleClasses} id={dialogTitleId}>
      <FormattedMessage id="changeResourceDialog.title" />
      {!isSubmitting && (
        <IconButton
          aria-label={formatMessage({
            id: 'changeResourceDialog.close'
          })}
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      )}
    </DialogTitle>
  );
};

ChangeResourceDialogTitle.propTypes = {
  dialogTitleId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};
